import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setIsLoading, setIsPaymentProcessing } from '../../actions/payment'
import {
  fetchProductDetailsAsync,
  makeFilePaymentAsync,
} from '../../services/paymentService'
import { RootState } from '../../store'
import { formatCurrency } from '../../utils/Common'
import { showOneTimeServicePaymentDialog } from '../../actions/organization'

export default function OneTimeServicePayment() {
  const dispatch = useDispatch<any>()
  const isLoading = useSelector((state: RootState) => state.payment.isLoading)
  const pricingProduct = useSelector(
    (state: RootState) => state.payment.pricingProduct,
  )
  const priceId = pricingProduct?.price?.id
  const organizationId = useSelector(
    (state: RootState) => state.organization.selectedOrganization?.id,
  )
  const fileId = useSelector(
    (state: RootState) => state.organization.selectedFile?.id,
  )
  const productName = useSelector(
    (state: RootState) => state.payment.selectedOneTimePaymentProductName,
  )

  useEffect(() => {
    dispatch(setIsLoading(true))
    dispatch(fetchProductDetailsAsync(productName!))
  }, [dispatch])

  const handleMakePayment = () => {
    dispatch(setIsPaymentProcessing(true))
    dispatch(
      makeFilePaymentAsync({
        organizationId,
        priceId,
        fileId,
        productId: pricingProduct.id,
        productName: pricingProduct.name,
        amount: pricingProduct.price.unit_amount / 100,
        currency: pricingProduct.price.currency,
      }),
    )
  }

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Box>
          <Box
            sx={{
              marginTop: '-2px',
            }}
          >
            <img src='/images/topRectangle.png'></img>
          </Box>

          <Box
            sx={{
              width: '473px',
              height: '263px',
            }}
          >
            {pricingProduct?.price ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  height: '100%',
                  padding: '0px 40px',
                  textAlign: 'center',
                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    color: '#06004A',

                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                  }}
                >
                  Confirm Service Request
                </Typography>
                <Typography
                  sx={{
                    color: '#06004A',

                    fontWeight: 400,
                    fontSize: '18px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                  }}
                >
                  This service requires a payment of{' '}
                  {formatCurrency(pricingProduct?.price?.unit_amount)}. Would
                  you like to proceed?
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <Button
                    sx={{
                      border: '1px solid #FF0000',
                      color: '#FF0000',

                      fontWeight: 500,
                      fontSize: '12px',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                    }}
                    onClick={() =>
                      dispatch(showOneTimeServicePaymentDialog(false))
                    }
                  >
                    <Typography
                      sx={{
                        textTransform: 'none',

                        fontWeight: 500,
                        fontSize: '12px',
                        lineHeight: '100%',
                        letterSpacing: '0%',
                        textAlign: 'center',
                        verticalAlign: 'middle',
                      }}
                    >
                      Go Back
                    </Typography>
                  </Button>
                  <Button
                    sx={{
                      background: '#1705E5',
                      color: 'white',
                    }}
                    onClick={handleMakePayment}
                  >
                    <Typography
                      sx={{
                        textTransform: 'none',

                        fontWeight: 500,
                        fontSize: '12px',
                      }}
                    >
                      Confirm & Pay
                    </Typography>
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  height: '100%',
                  padding: '0px 40px',
                  textAlign: 'center',
                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    color: '#06004A',

                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                  }}
                >
                  Unable to Load Service
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </>
  )
}
